import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { UsersFilter } from '../models';
import { Table } from '@/components';
import {
  Visibility as VisibilityIcon,
  Edit as EditIcon,
} from '@mui/icons-material';
import { userTableColumns } from '../config';
import { useUsers, useUsersPagination } from '../hooks';
import { IconButton } from '@mui/material';

import styles from './UsersTable.module.css';

type UsersTableProps = {
  usersFilter?: UsersFilter;
};

const UsersTable = ({ usersFilter }: UsersTableProps) => {
  const navigate = useNavigate();
  const columns = useMemo(() => userTableColumns, []);

  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    useUsersPagination();

  const { users, isUsersLoading, totalItems, totalPages } = useUsers({
    paginated: {
      page: currentPage,
      pageSize: pageSize,
    },
    filters: usersFilter,
  });

  const renderActions = (rowData: Record<string, any>) => (
    <>
      <IconButton onClick={() => navigate(`/inventory/users/${rowData.id}`)}>
        <VisibilityIcon />
      </IconButton>
      <IconButton onClick={() => navigate(`/inventory/users/${rowData.id}/edit`)}>
        <EditIcon />
      </IconButton>
    </>
  );

  return (
    <div className={styles.content}>
      {users?.length > 0 ? (
        <Table
          columns={columns}
          data={users}
          renderActions={renderActions}
          isLoading={isUsersLoading}
          pagination={{
            totalItems,
            totalPages,
            currentPage,
            rowsPerPage: pageSize,
            onPageChange: handlePageChange,
            onRowsPerPageChange: handlePageSizeChange,
          }}
        />
      ) : (
        'No hay registros por el momento'
      )}
    </div>
  );
};

export default UsersTable;
